module.exports = __webpack_public_path__ + "static/media/tail-right.72debee5.svg";